"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedResponseOfShiftListItemDto = instanceOfPaginatedResponseOfShiftListItemDto;
exports.PaginatedResponseOfShiftListItemDtoFromJSON = PaginatedResponseOfShiftListItemDtoFromJSON;
exports.PaginatedResponseOfShiftListItemDtoFromJSONTyped = PaginatedResponseOfShiftListItemDtoFromJSONTyped;
exports.PaginatedResponseOfShiftListItemDtoToJSON = PaginatedResponseOfShiftListItemDtoToJSON;
exports.PaginatedResponseOfShiftListItemDtoToJSONTyped = PaginatedResponseOfShiftListItemDtoToJSONTyped;
const ShiftListItemDto_1 = require("./ShiftListItemDto");
const PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1 = require("./PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta");
/**
 * Check if a given object implements the PaginatedResponseOfShiftListItemDto interface.
 */
function instanceOfPaginatedResponseOfShiftListItemDto(value) {
    if (!('result' in value) || value['result'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedResponseOfShiftListItemDtoFromJSON(json) {
    return PaginatedResponseOfShiftListItemDtoFromJSONTyped(json, false);
}
function PaginatedResponseOfShiftListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'result': (json['result'].map(ShiftListItemDto_1.ShiftListItemDtoFromJSON)),
        'meta': (0, PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1.PaginatedResponseOfFacilityOrientationListItemDtoAllOfMetaFromJSON)(json['meta']),
    };
}
function PaginatedResponseOfShiftListItemDtoToJSON(json) {
    return PaginatedResponseOfShiftListItemDtoToJSONTyped(json, false);
}
function PaginatedResponseOfShiftListItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'result': (value['result'].map(ShiftListItemDto_1.ShiftListItemDtoToJSON)),
        'meta': (0, PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1.PaginatedResponseOfFacilityOrientationListItemDtoAllOfMetaToJSON)(value['meta']),
    };
}
//# sourceMappingURL=PaginatedResponseOfShiftListItemDto.js.map